import type { UserInfo } from "@/stores/auth";
import { api } from "./api";

interface LoginResponse {
  tokens: { access_token: string; refresh_token: string; expires_in: number };
  user: UserInfo;
}

interface SsoAuthorizeResponse {
  authorize_url: string;
  state: string;
}

export const authService = {
  register: (name: string, account: string, password: string) =>
    api.post<UserInfo>("/auth/register", { name, account, password }),

  login: (account: string, password: string) =>
    api.post<LoginResponse>("/auth/login", { account, password }),

  logout: () => api.post("/auth/logout"),

  ssoAuthorize: (orgId: string, redirectUri: string) =>
    api.get<SsoAuthorizeResponse>(`/auth/sso/${orgId}/authorize?redirect_uri=${encodeURIComponent(redirectUri)}`),

  ssoExchangeToken: (orgId: string, code: string, state: string) =>
    api.post<LoginResponse>(`/auth/sso/${orgId}/token`, { code, state }),
};
